import { ChartConfiguration } from "chart.js";
import { backgroundColorLighter } from "~/variables";
import { $t } from "~/i18n";

export const config: ChartConfiguration = {
    type: 'bar',
    data: {
        datasets: [],
    },
    options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        scales: {
            y: {
                stacked: true,
                suggestedMin: 0,
                ticks: { color: 'white', maxTicksLimit: 6},
                display: true,
                grid: {
                    display: true,
                    color: backgroundColorLighter,
                },
                title: {
                    display: true,
                    align: 'center',
                    text: $t('alarm_chart.scale.y.title'),
                    color: 'white',
                },
            },
            x: {
                stacked: true,
                offset: true,
                grid: {
                    display: true,
                    color: backgroundColorLighter
                },
                ticks: {
                    display: true,
                    maxRotation: 0,
                    align: "center",
                    crossAlign: "far",
                    color: 'white',
                    maxTicksLimit: 5,
                }
            }
        },
        plugins: {
            tooltip: {
                callbacks: {

                }
            },
            legend: {
                display: true,
            },

            datalabels: {
                color: 'white',
                formatter: (val) => (val > 0 ? val : '')
            }
        }
    }
}